import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { SortDirection } from "./interfaces";
export var useSort = function useSort() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      defaultSortDirection = _ref.defaultSortDirection,
      defaultActiveSortId = _ref.defaultActiveSortId;

  var _useState = useState(defaultSortDirection || SortDirection.None),
      _useState2 = _slicedToArray(_useState, 2),
      sortDirection = _useState2[0],
      setSortDirection = _useState2[1];

  var _useState3 = useState(defaultActiveSortId),
      _useState4 = _slicedToArray(_useState3, 2),
      activeSortId = _useState4[0],
      setActiveSortId = _useState4[1];

  var onSort = function onSort(_ref2) {
    var sortId = _ref2.sortId,
        sortDirection = _ref2.sortDirection;
    setSortDirection(sortDirection);
    setActiveSortId(sortId);
  };

  return {
    activeSortId: activeSortId,
    sortDirection: sortDirection,
    onSort: onSort
  };
};